import { render, staticRenderFns } from "./StocksViewStockProvideProducts.vue?vue&type=template&id=d1fbee44&scoped=true"
import script from "./StocksViewStockProvideProducts.vue?vue&type=script&lang=js"
export * from "./StocksViewStockProvideProducts.vue?vue&type=script&lang=js"
import style0 from "./StocksViewStockProvideProducts.vue?vue&type=style&index=0&id=d1fbee44&prod&lang=scss"
import style1 from "./StocksViewStockProvideProducts.vue?vue&type=style&index=1&id=d1fbee44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fbee44",
  null
  
)

export default component.exports